import { Route, Switch, useLocation } from 'react-router-dom';
import useRouter from './useRouter';
import Layout from '../components/Layout';
import NotFound from '../pages/NotFound';
import { ConnectionChecker } from '../components/Errors/index';

const RouteConfig = () => {
	const { pathname } = useLocation();
	const { routes } = useRouter();

	const isFreshchat = pathname.startsWith('/freshchatframe');
	const isUfoodX = pathname.startsWith('/ufood-x');

	const renderRoutes = () => (
		<Switch>
			{routes.map(({ exact, index, path, component }) => (
				<Route key={path} {...{ index, exact, path, component }} />
			))}
			<Route component={NotFound} />
		</Switch>
	);

  return <ConnectionChecker>{isFreshchat ? renderRoutes() : isUfoodX ? renderRoutes() : <Layout>{renderRoutes()}</Layout>}</ConnectionChecker>;
};

export default RouteConfig;
